import { DataConverter } from "../../../../../Global/Base/Converters/DataConverter";
import { createElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { AlignType } from "../../Controls/ControlEnums";
import { UIManager, UIManager as uiManager } from "../../UIManager";
import { BaseAlignElement } from "./BaseAlignElement";
import { ControlElement } from "./ControlElement";

const EXTENDED_PROTPERTIE_ATTRIBUTE = "data-extendedproperties";

/**
 * Pomocny dokovaci element
 */
export class AlignDockHelperContainer {
    public element: HTMLElement;
    public isGroupBox: boolean = false;

    constructor(element: BaseAlignElement, parentElement: HTMLElement, stylesheet?: HTMLStyleElement) {
        this._createElement(element.alignType);

        if (element.element.getAttribute("data-tsccontrol") === "GroupBox") {
            this.isGroupBox = true;
            this.element.classList.add("GroupBoxContainer");
        }

        if (element.element.hasAttribute(EXTENDED_PROTPERTIE_ATTRIBUTE)) {
            this.element.setAttribute(EXTENDED_PROTPERTIE_ATTRIBUTE, element.element.getAttribute(EXTENDED_PROTPERTIE_ATTRIBUTE));
        }

        const useLabel = !DataConverter.toBoolean(element.element.getAttribute("data-ignorecaption"), false);
        const locKey = element.element.getAttribute("data-captionLocKey");

        if (useLabel && locKey && !locKey.endsWith("-666")) {
            const label = ControlElement.getCaptionElement(element.element.id, element.element.getAttribute("data-captionLocKey"));
            this.element.appendChild(label.element);

            if (stylesheet && !this.isGroupBox) {
                const generatedId = uiManager.instance.generateElementID();
                label.element.classList.add(generatedId);

                let styleData = `.AlignPanel.fits .${generatedId} {`;
                styleData += `  top: ${BaseAlignElement.parseNum(element.element.getAttribute("data-captiontop"))}px;\n`;
                styleData += `  left: ${BaseAlignElement.parseNum(element.element.getAttribute("data-captionleft"))}px;\n`;
                styleData += `  max-width: ${element.width}px;\n`;
                styleData += "  width: auto; \n";
                styleData += "}";

                stylesheet.innerHTML += styleData;
            }
        }

        this.element.appendChild(element.element);
        parentElement.classList.remove("Column", "Row");

        if (element.alignType === AlignType.top || element.alignType === AlignType.bottom) {
            this.element.style.height = element.height + element.margin.top + element.margin.bottom + "px";
            this.element.style.flexShrink = "0";
            parentElement.classList.add("Column");
        } else if (element.alignType === AlignType.left || element.alignType === AlignType.right) {
            this.element.style.width = element.width + element.margin.left + element.margin.right + "px";
            this.element.style.flexShrink = "0";
            parentElement.classList.add("Row");
        } else {
            //this.element.style.minHeight = element.height + "px";
            //this.Element.style.minWidth = element.width + "px";
            parentElement.classList.add("client");
        }

        parentElement.appendChild(this.element);

        if (element.margin?.isNonZero) {
            (this.isGroupBox ? this.element : element.element).style.margin = element.margin.toString();
        }
    }

    protected _createElement(align: AlignType): void {
        this.element = createElement({ classes: ["AlignDockHelperContainer", AlignType[align]], id: UIManager.instance.generateElementID() });
    }
}
